// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Qtym","content":"Consent_content__11Wd7","footer":"Consent_footer__2h-ST"};